type Props = {
	count: number;
	label?: string;
	className?: string;
	position?: string;
};
function Dib({ count, label, position = "top-2 right-0" }: Props) {
	return (
		<span
			className={`absolute ${position} w-auto px-1 text-xs text-white bg-danger border-2 border-white rounded-full`}
		>
			{count} {label && <span className="sr-only">{label}</span>}
		</span>
	);
}

export default Dib;
